const getLastPartBucketQueryStartDate = (store) => {
  return store.partCountBuckets.queryArgs.startDate;
};

export { getLastPartBucketQueryStartDate };
